import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import Router from './Presentation/index';
import Router2 from './Presentation/router';
import GlobalStyl from './Presentation/Global/index';
// import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from 'styled-components';
import theme from '@ds/components/bosons/Theme';

// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

export type AppProps = {
  code?: string;
  newPlayer?: boolean;
};

// <React.StrictMode>
const App = ({ code, newPlayer }: AppProps) => newPlayer ? (
  // <BrowserRouter>
  //   <GlobalStyl />
  //   <ThemeProvider theme={theme['dark']}>
  //     <Router />
  //   </ThemeProvider>
  // </BrowserRouter>
  // <BrowserRouter>
  <BrowserRouter>
    <GlobalStyl />
    <ThemeProvider theme={theme['dark']}>
      <Router2 code={code || ''} />
    </ThemeProvider>
  </BrowserRouter>
  // </BrowserRouter>
) : (
  <BrowserRouter>
    <GlobalStyl />
    <ThemeProvider theme={theme['dark']}>
      <Router />
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
// </React.StrictMode>
